const simpleForm = (editor) => {

    editor.BlockManager.add('simpleForm', {
        label: `
                    <svg  width="1.4vw" height="1.4vw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path class="gjs-block-svg-path" d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
                      <path class="gjs-block-svg-path" d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
                      <rect class="gjs-block-svg-path" x="2" y="15" width="10" height="3" rx="0.5"></rect>
                    </svg>
                    <div class='gjs-fontFamily gjs-block-label'>Simple Form</div>
                  `,
        category: 'Forms ',
        content: `
        <div class="row d-flex justify-content-center p-3">
        <div class="col-md-5 mb-4">
          <div class="card mb-4 rounded-3 shadow-lg">
            <div class="card-header py-3">
              <h5 class="mb-0">Form</h5>
            </div>
            <div class="card-body">
              <form wablitype="form" wabliname="form">
                <!-- 2 column grid layout with text inputs for the first and last names -->
                <div class="row mb-4">
                  <div class="col">
                    <div class="form-outline">
                      <label class="form-label fw-bolder" for="form6Example1">First name</label>
                      <input type="text" id="form6Example1" class="form-control" placeholder="First Name"/>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-outline">
                      <label class="form-label fw-bolder" for="form6Example2">Last name</label>
                      <input type="text" id="form6Example2" class="form-control" placeholder="Last Name" />
                    </div>
                  </div>
                </div>

                <!-- Text input -->
                <div class="form-outline mb-4">
                  <label class="form-label fw-bolder" for="form6Example3">Company name</label>
                  <input type="text" id="form6Example3" class="form-control" placeholder="Company Name"/>
                </div>

                <!-- Text input -->
                <div class="form-outline mb-4">
                  <label class="form-label fw-bolder" for="form6Example4">Address</label>
                  <input type="text" id="form6Example4" class="form-control" placeholder="Address"/>
                </div>

                <!-- Email input -->
                <div class="form-outline mb-4">
                  <label class="form-label fw-bolder" for="form6Example5">Email</label>
                  <input type="email" id="form6Example5" class="form-control" placeholder="Email"/>
                </div>

                <!-- Number input -->
                <div class="form-outline mb-4">
                  <label class="form-label fw-bolder" for="form6Example6">Phone</label>
                  <input type="number" id="form6Example6" class="form-control" placeholder="Phone"/>
                </div>

                <hr class="my-4" />

                <div class="form-check mb-4" wablitype='radios'>
                  <input class="form-check-input" type="checkbox" value="" id="checkoutForm2"/>
                  <label class="form-check-label" for="checkoutForm2">
                    I accept the terms & conditions.
                  </label>
                </div>

                <button class="btn btn-primary btn-lg btn-block shadow-lg" type="submit">
                  Done
                </button>
              </form>
            </div>
          </div>
        </div>

      </div>
                        `,
        attributes: {}
    });

    
}

export default simpleForm;